import React from 'react'
import styled from 'styled-components'
import { darkGrayColor } from 'uiComponents/constants/colors'
import { fsXS, fsXXXS } from 'uiComponents/constants/typography'

const LowestProductPrice30D: React.FC<{
  label?: string
  className?: string
}> = ({ label, className }) => {
  if (!label) {
    return null
  }

  return (
    <Wrapper data-testid="lowestProductPrice30D" className={className}>
      {label}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  font-size: ${fsXXXS}px;
  line-height: ${fsXS}px;
  color: ${darkGrayColor};
`

export default LowestProductPrice30D
